import { SCREEN_BREAKPOINT_MIN } from '@/constants';

export const isMobile = (windowWidth: number): boolean => windowWidth < SCREEN_BREAKPOINT_MIN.SM;
